import _defineProperty from 'babel-runtime/helpers/defineProperty';
export default {
  methods: {
    alignCls: function alignCls(column) {
      var _ref;

      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var cellClassName = '';
      if (row.cellClassName && column.key && row.cellClassName[column.key]) {
        cellClassName = row.cellClassName[column.key];
      }
      return [(_ref = {}, _defineProperty(_ref, '' + cellClassName, cellClassName), _defineProperty(_ref, '' + column.className, column.className), _defineProperty(_ref, this.prefixCls + '-column-' + column.align, column.align), _ref)];
    },
    isPopperShow: function isPopperShow(column) {
      return column.filters && (!this.fixed && !column.fixed || this.fixed === 'left' && column.fixed === 'left' || this.fixed === 'right' && column.fixed === 'right');
    },
    setCellWidth: function setCellWidth(column) {
      var width = '';
      if (column.width) {
        width = column.width;
      } else if (this.columnsWidth[column._index]) {
        width = this.columnsWidth[column._index].width;
      }
      if (width === '0') width = '';
      return width;
    }
  }
};